import React from 'react';
import './IncomeProposalPreview.css';
import companyLogo from '../../../assets/images/company-logo.png';
import companySeal from '../../../assets/images/seal_ceo.png';
import html2pdf from 'html2pdf.js';

// 📂 문서종류-카테고리-세부구분별 문구 매핑
const CONTENT_TEMPLATES = {
  // ── 수입기안 ──
  "income_draft-경영팀-수입보고": {
    intro: (month) => `경영팀 ${month} 수입보고를 아래와 같이 보고합니다.`,
    labels: { item1: "건      명", item2: "금      액", item3: "업  체 명", item4: "입금방법", item5: "청구일자" },
  },
  "income_draft-환경/소독-대금청구": {
    intro: (month) => `환경/소독 ${month} 대금청구를 아래와 같이 보고합니다.`,
    labels: { item1: "건      명", item2: "청구금액", item3: "업  체 명", item4: "입금방법", item5: "청구일자" },
  },
  "income_draft-환경/소독-기성계": {
    intro: (month) => `환경/소독 ${month} 기성을 아래와 같이 보고합니다.`,
    labels: { item1: "건      명", item2: "기성금액", item3: "발  주 처", item4: "입금방법", item5: "청구일자" },
  },
  "income_draft-환경/소독-완수계": {
    intro: (month) => `환경/소독 ${month} 완수를 아래와 같이 보고합니다.`,
    labels: { item1: "건      명", item2: "완수금액", item3: "발  주 처", item4: "입금방법", item5: "청구일자" },
  },
  "income_draft-환경/소독-준공계": {
    intro: (month) => `환경/소독 ${month} 준공을 아래와 같이 보고합니다.`,
    labels: { item1: "건      명", item2: "준공금액", item3: "발  주 처", item4: "입금방법", item5: "청구일자" },
  },
  "income_draft-환경/종합-대금청구": {
    intro: (month) => `환경/종합 ${month} 대금청구를 아래와 같이 보고합니다.`,
    labels: { item1: "건      명", item2: "청구금액", item3: "업  체 명", item4: "입금방법", item5: "청구일자" },
  },
  "income_draft-환경/종합-기성계": {
    intro: (month) => `환경/종합 ${month} 기성을 아래와 같이 보고합니다.`,
    labels: { item1: "건      명", item2: "기성금액", item3: "발  주 처", item4: "입금방법", item5: "청구일자" },
  },
  "income_draft-환경/종합-완수계": {
    intro: (month) => `환경/종합 ${month} 완수를 아래와 같이 보고합니다.`,
    labels: { item1: "건      명", item2: "완수금액", item3: "발  주 처", item4: "입금방법", item5: "청구일자" },
  },
  "income_draft-환경/종합-준공계": {
    intro: (month) => `환경/종합 ${month} 준공을 아래와 같이 보고합니다.`,
    labels: { item1: "건      명", item2: "준공금액", item3: "발  주 처", item4: "입금방법", item5: "청구일자" },
  },
  "income_draft-용역사업-기성계": {
    intro: (month) => `용역사업 ${month} 기성을 아래와 같이 보고합니다.`,
    labels: { item1: "건      명", item2: "기성금액", item3: "발  주 처", item4: "입금방법", item5: "청구일자" },
  },
  "income_draft-용역사업-완수계": {
    intro: (month) => `용역사업 ${month} 완수를 아래와 같이 보고합니다.`,
    labels: { item1: "건      명", item2: "완수금액", item3: "발  주 처", item4: "입금방법", item5: "청구일자" },
  },
  "income_draft-용역사업-준공계": {
    intro: (month) => `용역사업 ${month} 준공을 아래와 같이 보고합니다.`,
    labels: { item1: "건      명", item2: "준공금액", item3: "발  주 처", item4: "입금방법", item5: "청구일자" },
  },
};

// 기본 템플릿 (매칭 안 될 때)
const DEFAULT_TEMPLATE = {
  intro: (month) => `${month} 관련 건을 아래와 같이 보고합니다.`,
  labels: { item1: "건      명", item2: "금      액", item3: "업  체 명", item4: "입금방법", item5: "청구일자" },
};

// ✅ 표 레이아웃을 사용하는 템플릿 키 목록
const TABLE_LAYOUT_KEYS = [
  "income_draft-환경/소독-대금청구",
  "income_draft-환경/종합-대금청구",
];

// ✅ 날짜를 "2026. 2. 5. (목)" 형식으로 변환
const formatDateWithDay = (dateStr) => {
  if (!dateStr) return '';
  const days = ['일', '월', '화', '수', '목', '금', '토'];
  const d = new Date(dateStr);
  const y = d.getFullYear();
  const m = d.getMonth() + 1;
  const day = d.getDate();
  const dayName = days[d.getDay()];
  return `${y}. ${m}. ${day}. (${dayName})`;
};

// ✅ 날짜를 "2026년 2월 5일" 형식으로 변환 (본문용)
const formatDateKorean = (dateStr) => {
  if (!dateStr) return '';
  const [y, m, d] = dateStr.split('-');
  return `${y}년 ${parseInt(m)}월 ${parseInt(d)}일`;
};

// ✅ 붙임 자료 렌더링 컴포넌트
const AttachmentSection = ({ attachments }) => {
  if (!attachments || attachments.length === 0) return null;

  if (attachments.length === 1) {
    // 1개: 붙임  입력값 N부.  끝.
    return (
      <div className="content-attachment">
        <span className="attachment-label">붙임</span>
        <span className="attachment-text">
          &nbsp;&nbsp;{attachments[0].name} {attachments[0].count}부.&nbsp;&nbsp;끝.
        </span>
      </div>
    );
  }

  // 2개 이상: 번호 매기기, 마지막에만 끝.
  return (
    <div className="content-attachment">
      <span className="attachment-label">붙임</span>
      <span className="attachment-lines">
        {attachments.map((att, idx) => (
          <span key={att.id || idx} className="attachment-line">
            &nbsp;&nbsp;{idx + 1}. {att.name} {att.count}부.
            {idx === attachments.length - 1 && <>&nbsp;&nbsp;끝.</>}
          </span>
        ))}
      </span>
    </div>
  );
};

const IncomeProposalPreview = ({
  formData,
  approvalLine = [],
  companyInfo,
  onSave,
  saving = false,
  onActiveViewChange,  // ✅ 용역 청구형(내부기안/공문) 탭 전환 콜백
}) => {
  // 귀속월 포맷 함수
  const formatWorkMonth = (workMonth) => {
    if (!workMonth) return '귀속월';
    const [year, month] = workMonth.split('-');
    return `${year}년 ${parseInt(month)}월`;
  };

  // ✅ 현재 조합에 맞는 템플릿 가져오기
  const templateKey = `${formData?.documentType || 'income_draft'}-${formData?.businessType || ''}-${formData?.detailOption || ''}`;
  const template = CONTENT_TEMPLATES[templateKey] || DEFAULT_TEMPLATE;
  const formattedMonth = formatWorkMonth(formData?.workMonth);

  const isTable = TABLE_LAYOUT_KEYS.includes(templateKey);

  // ✅ 용역 수입기안 청구형(공단 계약, 내부기안+공문 2벌) — 하나의 문서에서 탭으로 전환.
  // businessType(카테고리)이 "용역사업"일 때만 발동 — tableType 단독 검사만으로는 카테고리를
  // 바꿔도 이전 선택의 tableType이 남아있는 경우 다른 카테고리(예: 환경/소독)의 렌더링까지
  // 용역 청구형으로 오염시키는 회귀가 있었다.
  const isYongyeokClaim = formData?.businessType === "용역사업" && formData?.tableType === "yongyeok_claim";
  // ✅ 용역 수입기안 제출형(기성계 제출) — 청구형과 같은 내부/공문 탭 인프라를 공유하되
  // 표·회차·자동계산이 없는 더 단순한 버전
  const isYongyeokSubmit = formData?.businessType === "용역사업" && formData?.tableType === "yongyeok_submit";
  const activeView = formData?.activeView || "internal";
  const isOfficial = (isYongyeokClaim || isYongyeokSubmit) && activeView === "official";

  const yc = isYongyeokClaim
    ? (() => {
        const contractAmount = Number(formData?.yongyeokContractAmount) || 0;
        const prevAmount = Number(formData?.yongyeokPrevAmount) || 0;
        const prevCumulative = Number(formData?.yongyeokPrevCumulative) || 0;
        const claim = Number(formData?.amount) || 0;
        const throughThisRound = prevCumulative + claim;
        const available = contractAmount - throughThisRound;
        const contractName = formData?.yongyeokContractName || "";
        const siteTitle = contractName.replace(/^\d{4}년\s*/, "");
        return {
          round: formData?.yongyeokRound || "",
          contractAmount,
          prevAmount,
          prevCumulative,
          claim,
          throughThisRound,
          available,
          contractName,
          siteTitle,
          referenceLabel: formData?.yongyeokReferenceLabel || "",
          internalDraftNo: formData?.documentNumber || "",
          officialDraftNo: formData?.officialDraftNo || "",
        };
      })()
    : null;

  const ys = isYongyeokSubmit
    ? (() => {
        const [year, month] = (formData?.workMonth || "").split("-");
        const monthNum = month ? parseInt(month, 10) : "";
        return {
          year: year || "",
          month: monthNum,
          serviceName: formData?.yongyeokSubmitServiceName || "",
          recipient: formData?.yongyeokSubmitRecipient || "",
          honorific: formData?.yongyeokSubmitHonorific || "",
          viaLabel: formData?.yongyeokSubmitViaLabel || "",
          internalDraftNo: formData?.documentNumber || "",
          officialDraftNo: formData?.officialDraftNo || "",
        };
      })()
    : null;



  // ✅ [추가] 냉난방기 종합세척 상세내역 (quantity > 0 && unit_price > 0 인 행만)
  const validAircondDetails = (formData?.aircondDetails || []).filter(
    d => (d.quantity || 0) > 0 && (d.unit_price || 0) > 0
  );
  const isAircond =
    formData?.businessType === "환경/종합" &&
    formData?.detailType === "냉난방기 종합세척" &&
    validAircondDetails.length > 0;

  // ✅ 환경/종합 개인고객 대금청구 — 소독 원형 렌더링 계열(표 레이아웃) 기반, 용역 청구형
  // 인프라(탭/세트/직인) 사용 안 함. 금액은 저장된 contract_amount(수기 계산이라 오류
  // 가능)를 신뢰하지 않고 대수×단가로 항상 재계산해서 원본 PDF의 수기 계산 오류
  // (스탠드형 143,000 등)가 재발하지 않게 한다.
  const isPersonalAircond =
    formData?.businessType === "환경/종합" && formData?.detailOption === "개인고객 대금청구";
  const personalAircondRows = isPersonalAircond
    ? validAircondDetails.map((d) => ({
        type: d.aircond_type,
        quantity: Number(d.quantity) || 0,
        unitPrice: Number(d.unit_price) || 0,
        amount: (Number(d.quantity) || 0) * (Number(d.unit_price) || 0),
      }))
    : [];
  const personalAircondTotal = {
    quantity: personalAircondRows.reduce((s, r) => s + r.quantity, 0),
    amount: personalAircondRows.reduce((s, r) => s + r.amount, 0),
  };

  // ✅ 유효한 붙임 자료 필터링
  const validAttachments = (formData?.attachments || []).filter(att => att.name && att.name.trim() !== '');


  // 결재라인 정렬 (기안 → 합의 → 결재 순서)
  const sortedApprovalLine = [...approvalLine].sort((a, b) => {
    const order = { '기안': 1, '합의': 2, '결재': 3 };
    return (order[a.status] || 999) - (order[b.status] || 999);
  });

  // ✅ 공문(원본 형식) 결재 표시 — 담당자(기안자, 담당자급일 때만)/팀장/대표이사만
  // 가로 한 줄. 중간 결재자(대리 등)는 표기하지 않는다. "담당자"는 문서상 호칭일 뿐
  // 실제 직위 문자열(주임/대리 등)과 무관하므로, 기안자의 직위가 팀장/대표이사가
  // 아닐 때만("담당자급") 담당자 행을 넣고 그 직위 라벨 대신 "담당자"로 고정 표기한다.
  const drafterLine = sortedApprovalLine.find((a) => a.status === '기안');
  const teamLeaderLine = sortedApprovalLine.find((a) => a.position === '팀장');
  const ceoLine = sortedApprovalLine.find((a) => a.position === '대표이사');
  const isDrafterStaff = drafterLine && drafterLine.position !== '팀장' && drafterLine.position !== '대표이사';
  const officialApprovalEntries = [
    isDrafterStaff && { label: '담당자', name: drafterLine.name },
    teamLeaderLine && { label: '팀장', name: teamLeaderLine.name },
    ceoLine && { label: '대표이사', name: ceoLine.name },
  ].filter(Boolean);

  // ✅ 공문 레이아웃 2차 조정 — 결재라인~시행정보~주소~연락처 하단 고정 블록 전체를
  // 45px 아래로 내려(기존 bottom 값 그대로 -45), 확대된 발신명의·직인이 결재라인 위
  // 구분선을 침범하지 않도록 여유 확보. 내부기안 탭/제출형/소독 원형은 이 스타일이
  // 적용되지 않아(className 그대로) 기존 CSS 값(220/190/160/140/120px)이 그대로 유지된다.
  const isOfficialClaim = isYongyeokClaim && isOfficial;
  const officialFooterStyle = (basePx) => (isOfficialClaim ? { bottom: `${basePx - 45}px` } : undefined);

  // ✅ PDF 미리보기 (최적화)
  const handlePreviewPDF = () => {
    const element = document.querySelector('.preview-paper');
    
    // 임시로 스타일 조정
    const originalHeight = element.style.height;
    element.style.height = '297mm';
    element.style.minHeight = '297mm';
    element.style.maxHeight = '297mm';
    
    const opt = {
      margin: 0,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { 
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff',
        width: 794,   // ✅ 고정 너비
        height: 1123  // ✅ 고정 높이
      },
      jsPDF: { 
        unit: 'px',      // ✅ mm → px로 변경
        format: [794, 1123],  // ✅ A4 픽셀 크기
        orientation: 'portrait',
        hotfixes: ['px_scaling']  // ✅ 픽셀 스케일링 수정
      }
    };

    html2pdf()
      .set(opt)
      .from(element)
      .outputPdf('blob')
      .then((pdfBlob) => {
        // 원래 스타일 복구
        element.style.height = originalHeight;
        
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
        setTimeout(() => URL.revokeObjectURL(pdfUrl), 100);
      })
      .catch(() => {
        // 에러 시에도 스타일 복구
        element.style.height = originalHeight;
      });
  };

  // ✅ PDF 다운로드 (최적화)
  const handleDownloadPDF = () => {
    const element = document.querySelector('.preview-paper');
    
    // 임시로 스타일 조정
    const originalHeight = element.style.height;
    element.style.height = '297mm';
    element.style.minHeight = '297mm';
    element.style.maxHeight = '297mm';
    
    const opt = {
      margin: 0,
      filename: `${formData?.title || '수입기안서'}_${new Date().toISOString().slice(0, 10)}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { 
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff',
        width: 794,
        height: 1123
      },
      jsPDF: { 
        unit: 'px',
        format: [794, 1123],
        orientation: 'portrait',
        hotfixes: ['px_scaling']
      }
    };

    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        element.style.height = originalHeight;
      })
      .catch(() => {
        element.style.height = originalHeight;
      });
  };

  return (
    <div className="income-preview-wrapper">
      
      {/* ✅ 헤더 (제목 + 버튼 2개) */}
      <div className="preview-header">
        <h3 className="preview-title">📄 미리보기</h3>

        {(isYongyeokClaim || isYongyeokSubmit) && (
          <div style={{ display: 'flex', gap: '6px' }}>
            <button
              type="button"
              onClick={() => onActiveViewChange && onActiveViewChange('internal')}
              className="print-button"
              style={{
                width: '90px',
                height: '32px',
                background: activeView === 'internal' ? '#2563eb' : '#e5e7eb',
                color: activeView === 'internal' ? '#fff' : '#333',
              }}
            >
              내부기안
            </button>
            <button
              type="button"
              onClick={() => onActiveViewChange && onActiveViewChange('official')}
              className="print-button"
              style={{
                width: '90px',
                height: '32px',
                background: activeView === 'official' ? '#2563eb' : '#e5e7eb',
                color: activeView === 'official' ? '#fff' : '#333',
              }}
            >
              공문
            </button>
          </div>
        )}

        <div style={{ display: 'flex', gap: '10px' }}>
          {onSave && (
            <button 
              type="button"
              onClick={onSave}
              disabled={saving}
              className="print-button save-button"
            >
              {saving ? '⏳ 저장중...' : '💾 저장'}
            </button>
          )}
          <button 
            type="button"
            onClick={handlePreviewPDF}
            className="print-button preview-button"
          >
            👁️ PDF 미리보기
          </button>
          <button
            type="button"
            onClick={handleDownloadPDF}
            className="print-button download-button"
          >
            📥 PDF 다운로드
          </button>
          {(isYongyeokClaim || isYongyeokSubmit) && (
            <button
              type="button"
              onClick={() => window.print()}
              className="print-button"
              style={{ width: '90px', height: '32px' }}
            >
              🖨️ 인쇄
            </button>
          )}
        </div>
      </div>

      {/* 미리보기 컨테이너 */}
      <div className="income-preview-container">
        <div className="preview-paper">
          
          {/* 1. 회사로고 */}
          <div className="preview-logo-section">
            <div className="company-logo">
              <img 
                src={companyLogo} 
                alt="금천일자리 주식회사" 
                className="logo-image"
              />
            </div>
          </div>

          {/* 2. 수신 */}
          <div className="preview-field-row">
            <span className="field-label">수&nbsp;&nbsp;&nbsp;&nbsp;신</span>
            <span className="field-value">
              {isYongyeokClaim
                ? (isOfficial ? '금천구시설관리공단' : '내부결재')
                : isYongyeokSubmit
                ? (isOfficial ? ys.recipient : '내부결재')
                : (formData?.recipient || '내부결재')}
            </span>
          </div>

          {/* 3. (경유) — 제출형은 안양천처럼 경유가 있는 사업장만 공문 탭에서 표시 */}
          <div className="preview-field-row">
            <span className="field-label">(경&nbsp;&nbsp;유)</span>
            <span className="field-value">
              {isYongyeokSubmit && isOfficial ? ys.viaLabel : (formData?.via || '')}
            </span>
          </div>

          {/* 3-1. 참조 (용역 청구형 공문 전용 — 제출형엔 참조 개념 없음, 참조표기 없으면 행 자체를 생략) */}
          {isOfficial && yc?.referenceLabel && (
            <div className="preview-field-row">
              <span className="field-label">참&nbsp;&nbsp;&nbsp;&nbsp;조</span>
              <span className="field-value">{yc.referenceLabel} 업무 담당자</span>
            </div>
          )}

          {/* 4. 제목 */}
          <div className="preview-field-row title-row">
            <span className="field-label">제&nbsp;&nbsp;&nbsp;&nbsp;목</span>
            <span className="field-value">

              {formData?.title || '제목을 입력하세요'}
            </span>
          </div>

          {/* 5. 내용 */}
          <div className="preview-content-section">

            {isYongyeokClaim ? (
              /* ✅ 용역 수입기안 청구형(공단 계약) — 내부기안/공문 탭별 본문 + 실데이터 6칸 표 */
              <>
                <div className="content-intro">
                  {isOfficial ? (
                    <>
                      {/* ✅ 공문 레이아웃 2차 조정(용역-260702-031호 대조) — 두 문단 사이
                          기본 여백(브라우저 기본 <p> 마진) 제거, 원본처럼 촘촘하게. 내부기안
                          탭은 문단이 1개뿐이라 영향 없음 */}
                      <p style={{ margin: 0 }}>1. 귀 공단의 무궁한 발전을 기원합니다.</p>
                      <p style={{ margin: 0 }}>
                        2. 당사와 귀 공단과 체결한 {yc.contractName} 계약에 의거 제{yc.round}회 기성금을
                        아래와 같이 청구하오니 검토 부탁드립니다.
                      </p>
                    </>
                  ) : (
                    <p>
                      {formatWorkMonth(formData?.workMonth).split(' ')[0]} {yc.siteTitle} 제{yc.round}회
                      기성금을 아래와 같이 청구하고자 합니다.
                    </p>
                  )}
                </div>

                <div
                  className="content-separator"
                  style={{ marginBottom: '4px', ...(isOfficial ? { marginTop: '4px' } : {}) }}
                >
                  - 아 &nbsp;&nbsp; 래 -
                </div>

                <div style={{ textAlign: 'right', fontSize: '11px', marginBottom: '2px' }}>(단위: 원)</div>

                <table className="claim-table" style={{ marginTop: '0px' }}>
                  <thead>
                    <tr>
                      <th rowSpan={2} style={{ padding: '3px 4px' }}>계약금액</th>
                      <th colSpan={2} style={{ padding: '3px 4px' }}>금회기성금</th>
                      <th rowSpan={2} style={{ padding: '3px 4px' }}>기기성금액</th>
                      <th rowSpan={2} style={{ padding: '3px 4px' }}>금회까지<br/>기성금액</th>
                      <th rowSpan={2} style={{ padding: '3px 4px' }}>요청가능<br/>기성금액</th>
                    </tr>
                    <tr>
                      <th style={{ padding: '3px 4px' }}>청구금액</th>
                      <th style={{ padding: '3px 4px' }}>검사사정금액</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="amount-cell" style={{ padding: '3px 4px' }}>{yc.contractAmount.toLocaleString()}</td>
                      <td className="amount-cell" style={{ padding: '3px 4px' }}>{yc.claim.toLocaleString()}</td>
                      <td className="amount-cell" style={{ padding: '3px 4px' }}>{yc.claim.toLocaleString()}</td>
                      <td className="amount-cell" style={{ padding: '3px 4px' }}>{yc.prevAmount.toLocaleString()}</td>
                      <td className="amount-cell" style={{ padding: '3px 4px' }}>{yc.throughThisRound.toLocaleString()}</td>
                      <td className="amount-cell" style={{ padding: '3px 4px' }}>{yc.available.toLocaleString()}</td>
                    </tr>
                  </tbody>
                </table>

                <AttachmentSection attachments={validAttachments} />

                {isOfficial && (
                  /* ✅ 공문 레이아웃 2차 조정 — 발신명의 글자 약 1.86배(14px→26px) 확대,
                     직인도 비례 확대(60px→110px)해 원본처럼 텍스트 우측 3~4자를 덮도록
                     겹침 위치 재조정. 제출형 공문(isYongyeokSubmit)은 손대지 않음 */
                  <div className="content-signoff" style={{ textAlign: 'center', margin: '24px 0 8px', position: 'relative' }}>
                    <span style={{ position: 'relative', display: 'inline-block', fontWeight: 700, fontSize: '26px' }}>
                      금천일자리주식회사대표이사
                      <img
                        src={companySeal}
                        alt="직인"
                        className="content-signoff-seal"
                        style={{
                          position: 'absolute',
                          top: '-33px',
                          right: '-15px',
                          width: '110px',
                          height: '110px',
                          opacity: 0.85,
                          mixBlendMode: 'multiply',
                        }}
                      />
                    </span>
                  </div>
                )}
              </>

            ) : isYongyeokSubmit ? (
              /* ✅ 용역 수입기안 제출형(기성계 제출) — 표 없음, 본문 한 문장 + 붙임만 */
              <>
                <div className="content-intro">
                  {isOfficial ? (
                    <>
                      <p>1. {ys.honorific}의 무궁한 발전을 기원합니다.</p>
                      <p>2. {ys.year}년 {ys.serviceName} {ys.month}월 기성계를 붙임과 같이 제출합니다.</p>
                    </>
                  ) : (
                    <p>{ys.year}년 {ys.serviceName} {ys.month}월 기성계를 붙임과 같이 제출하고자 합니다.</p>
                  )}
                </div>

                <AttachmentSection attachments={validAttachments} />

                {isOfficial && (
                  <div className="content-signoff" style={{ textAlign: 'center', margin: '24px 0 8px', position: 'relative' }}>
                    <span style={{ position: 'relative', display: 'inline-block', fontWeight: 700 }}>
                      금천일자리주식회사대표이사
                      <img
                        src={companySeal}
                        alt="직인"
                        className="content-signoff-seal"
                        style={{
                          position: 'absolute',
                          top: '-18px',
                          right: '-50px',
                          width: '60px',
                          height: '60px',
                          opacity: 0.85,
                          mixBlendMode: 'multiply',
                        }}
                      />
                    </span>
                  </div>
                )}
              </>

            ) : isPersonalAircond ? (
              /* ✅ 환경/종합 개인고객 대금청구 — 구분/대수/단가/금액 표, 금액은 대수×단가 자동계산 */
              <>
                <div className="content-intro">
                  <p>
                    개인 고객 {(formData?.client || '').replace(/\(.*?\)/g, '').trim()}님 냉난방기 종합세척
                    대금을 아래와 같이 청구하고자 합니다.
                  </p>
                </div>

                <div className="content-separator">- 아 &nbsp;&nbsp; 래 -</div>
                <div style={{ textAlign: 'right', fontSize: '11px', marginBottom: '2px' }}>(단위: 원)</div>

                <table className="claim-table aircond-table">
                  <thead>
                    <tr>
                      <th>구분</th>
                      <th>대수(대)</th>
                      <th>단가(원)</th>
                      <th>금액(원)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {personalAircondRows.map((r, i) => (
                      <tr key={i}>
                        <td>{r.type}</td>
                        <td className="amount-cell">{r.quantity.toLocaleString()}</td>
                        <td className="amount-cell">{r.unitPrice.toLocaleString()}</td>
                        <td className="amount-cell" style={{ background: '#f3f4f6', color: '#666' }}>
                          {r.amount.toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr style={{ fontWeight: 700 }}>
                      <td>합계</td>
                      <td className="amount-cell">{personalAircondTotal.quantity.toLocaleString()}</td>
                      <td className="amount-cell">-</td>
                      <td className="amount-cell" style={{ background: '#f3f4f6', color: '#666' }}>
                        {personalAircondTotal.amount.toLocaleString()}
                      </td>
                    </tr>
                  </tfoot>
                </table>

                <AttachmentSection attachments={validAttachments} />
              </>

            ) : isTable ? (
              /* ✅ 대금청구 전용: 표 레이아웃 */
              <>


                <div className="content-intro">
                  <p>
                    {isAircond
                      ? `${(formData?.client || '').replace(/\(.*?\)/g, '').trim()} 냉난방기 종합세척 대금을 아래와 같이 청구하고자 합니다.`
                      : `${formatDateKorean(formData?.manualDate)} 실시한 ${(formData?.client || '').replace(`(${formData?.detailType || ''})`, '')} ${formData?.detailType || ''} 대금을 아래와 같이 청구하고자 합니다.`
                    }
                  </p>
                </div>


                <div className="content-separator">- 아 &nbsp;&nbsp; 래 -</div>
                <div style={{ textAlign: 'right', fontSize: '11px', marginBottom: '2px' }}>(단위: 원)</div>

                {/* ✅ [추가] 냉난방기 종합세척 상세내역 테이블 */}
                {isAircond && (
                  <table className="claim-table aircond-table">
                    <thead>
                      <tr>
                        <th>구분</th>
                        <th>대수(대)</th>
                        <th>단가(원)</th>
                        <th>계약금액(원)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {validAircondDetails.map((d, i) => (
                        <tr key={i}>
                          <td>{d.aircond_type}</td>
                          <td className="amount-cell">{(d.quantity || 0).toLocaleString()}</td>
                          <td className="amount-cell">{(d.unit_price || 0).toLocaleString()}</td>
                          <td className="amount-cell">{(d.contract_amount || 0).toLocaleString()}</td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr style={{ fontWeight: 700 }}>
                        <td>합계</td>
                        <td className="amount-cell">
                          {validAircondDetails.reduce((s, d) => s + (d.quantity || 0), 0).toLocaleString()}
                        </td>
                        <td className="amount-cell">-</td>
                        <td className="amount-cell">
                          {validAircondDetails.reduce((s, d) => s + (d.contract_amount || 0), 0).toLocaleString()}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                )}

                <table className="claim-table">
                  {/* ✅ 냉난방기가 아닐 때만 헤더+청구금액행 표시 */}
                  {!isAircond && (
                    <>
                      <thead>
                        <tr>
                          <th>구분</th>
                          <th>산출내역</th>
                          <th>금액(원)</th>
                          <th>비고</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>청구금액</td>
                          <td>{formattedMonth} 청구금액</td>
                          <td className="amount-cell">
                            {formData?.amount ? `${parseInt(formData.amount).toLocaleString()}원` : '-'}
                          </td>
                          <td>{formatDateWithDay(formData?.manualDate)} {formData?.detailType || ''}</td>
                        </tr>
                        <tr>
                          <td>거래방법</td>
                          <td colSpan="3">
                            {formData?.transactionType?.카드결제
                              ? '카드결제 / 환경사업 카드단말기(TID6822502404)'
                              : '계좌이체 / 예금주 : 우리은행 1005-004-763360 금천일자리주식회사'
                            }
                          </td>
                        </tr>
                      </tbody>
                    </>
                  )}

                  {/* ✅ 냉난방기일 때는 거래방법 행만 표시 */}
                  {isAircond && (
                    <tbody>
                      <tr>
                        <td>거래방법</td>
                        <td colSpan="3">
                          {formData?.transactionType?.카드결제
                            ? '카드결제 / 환경사업 카드단말기(TID6822502404)'
                            : '계좌이체 / 예금주 : 우리은행 1005-004-763360 금천일자리주식회사'
                          }
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>


                
                {/* ✅ 붙임 자료 (동적) */}
                <AttachmentSection attachments={validAttachments} />

              </>
            ) : (
              /* ✅ 기존: 번호 목록 레이아웃 */
              <>
              <div className="content-intro">
                {formData?.businessType && (
                  <p>
                    {formData?.content
                      ? formData.content   // ✅ desc(본문)가 있으면 우선 사용
                      : template.intro(formattedMonth)  // 없으면 템플릿 기본값
                    }
                  </p>
                )}
              </div>
                {!formData?.content && (
                <div className="content-details">
                  <div className="detail-item">
                    <span className="detail-number">1.</span>
                    <span className="detail-label">{template.labels.item1}:</span>
                    <span className="detail-text">
                      {formData?.title || '제목을 입력하세요'}
                    </span>
                  </div>

                  <div className="detail-item">
                    <span className="detail-number">2.</span>
                    <span className="detail-label">{template.labels.item2}:</span>
                    <span className="detail-text amount">
                      {formData?.amount ? `${parseInt(formData.amount).toLocaleString()}원(금${numberToKorean(formData.amount)})` : '-'}
                    </span>
                  </div>

                  <div className="detail-item">
                    <span className="detail-number">3.</span>
                    <span className="detail-label">{template.labels.item3}:</span>
                    <span className="detail-text">{formData?.client || '-'}</span>
                  </div>

                  <div className="detail-item">
                    <span className="detail-number">4.</span>
                    <span className="detail-label">{template.labels.item4}:</span>
                    <span className="detail-text">
                      {formData?.transactionType?.계좌이체 && '계좌이체'}
                      {formData?.transactionType?.카드결제 && '카드결제'}
                      {formData?.transactionType?.현금결제 && '현금결제'}
                      {!formData?.transactionType && '-'}
                    </span>
                  </div>

                  <div className="detail-item">
                    <span className="detail-number">5.</span>
                    <span className="detail-label">{template.labels.item5}:</span>
                    <span className="detail-text">
                      {formData?.manualDate || formData?.endDate || '-'}
                    </span>
                  </div>
                </div>
                )}

                {/* ✅ 붙임 자료 (동적) */}
                <AttachmentSection attachments={validAttachments} />
              </>
            )}

          </div>
          
                        

          {/* 7. 결재라인 — 공문(원본 형식)은 담당자/팀장/대표이사만, 내부기안은 현행 유지 */}
          <div className="preview-approval-line-simple" style={officialFooterStyle(220)}>
            {isOfficial
              ? officialApprovalEntries.map((entry, index) => (
                  <React.Fragment key={entry.label}>
                    {index > 0 && '          '}
                    <span>
                      {entry.label}
                      &nbsp;&nbsp;
                      {entry.name}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                  </React.Fragment>
                ))
              : sortedApprovalLine
                  .filter(approver => approver.status !== '합의')
                  .map((approver, index) => (
                    <React.Fragment key={approver.id}>
                      {/* 결재자 단위 사이의 큰 간격 (필요시 조정) */}
                      {index > 0 && '          '}

                      <span>
                        {/* 1. 직함 */}
                        {approver.position}

                        {/* 2. 직함과 이름 사이 (여기에 도장이 찍힘 - 약 10~12번 공백) */}
                        &nbsp;&nbsp;


                        {/* 3. 이름 */}
                        {approver.name}

                        {/* 4. 이름 뒤 여유 공간 (다음 결재자와의 거리 확보) */}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    </React.Fragment>
                  ))
            }
          </div>

          {/* 8. 협조자 — 공문은 원본 그대로 라벨만(값 없음), 내부기안은 현행 유지 */}
          <div className="preview-cooperator-line" style={officialFooterStyle(190)}>
            {isOfficial
              ? '협조자'
              : sortedApprovalLine
                  .filter(approver => approver.status === '합의')
                  .map((approver, index) => (
                    <React.Fragment key={approver.id}>
                      {index > 0 && '          '}
                      <span>{approver.position}  {approver.name}</span>
                    </React.Fragment>
                  ))
            }
          </div>

          {/* 9. 시행/기안번호/접수 */}
          <div className="preview-document-info" style={officialFooterStyle(160)}>
            <div className="doc-info-row">
              <span className="doc-label">시&nbsp;&nbsp;행</span>
              <span className="doc-value">
                {/* 앞에 공백 6번 추가 */}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {(isYongyeokClaim
                  ? (isOfficial ? yc.officialDraftNo : yc.internalDraftNo)
                  : isYongyeokSubmit
                  ? (isOfficial ? ys.officialDraftNo : ys.internalDraftNo)
                  : formData?.documentNumber
                )
                  ?.replace(/-[가-힣]+/g, '')
                  ?.replace(/\//g, '')
                  || ''}
              </span>
            </div>
          </div>

          {/* 10. 주소 */}
          <div className="preview-address-section" style={officialFooterStyle(140)}>
            <div className="address-row">
              <span className="zip-label">우&nbsp;&nbsp;편</span>
              {/* zip-code 앞의 &nbsp; 제거 */}
              <span className="zip-code">08592</span> 
              <span className="address-text">
                &nbsp;서울시 금천구 가산디지털2로 14, 201호(가산동, 대륭테크노타운12차) /
              </span>
            </div>
          </div>

          {/* 11. 전화/전송/이메일/공개 */}
          <div className="preview-contact-info" style={officialFooterStyle(120)}>
            <span className="contact-item">전&nbsp;&nbsp;화  02-854-9920</span>
            <span className="contact-divider">/</span>
            <span className="contact-item">전&nbsp;&nbsp;송  02-854-9921</span>
            <span className="contact-divider">/</span>
            <span className="contact-item">이메일 : gcjob@naver.com {formData?.email || ''}</span>
            <span className="contact-divider">/</span>
            <span className="contact-item">{(isYongyeokClaim || isYongyeokSubmit) ? '비공개' : '공개'}</span>
          </div>

        </div>
      </div>
    </div>
  );
};

// 숫자를 한글로 변환하는 함수
const numberToKorean = (num) => {
  if (!num) return '';
  const koreanNum = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
  const koreanUnit = ['', '십', '백', '천', '만', '십만', '백만', '천만', '억'];
  
  const numStr = String(num);
  let result = '';
  let unitIdx = 0;
  
  for (let i = numStr.length - 1; i >= 0; i--) {
    const digit = parseInt(numStr[i]);
    if (digit !== 0) {
      result = koreanNum[digit] + koreanUnit[unitIdx] + result;
    }
    unitIdx++;
  }
  
  return result || '영';
};

export default IncomeProposalPreview;